import {
  GET_WORKFLOW_QUEUES_REQUEST,
  GET_WORKFLOW_QUEUES_SUCCESS,
  GET_WORKFLOW_QUEUES_FAILURE,
  GET_WORKFLOW_QUEUE_REQUEST,
  GET_WORKFLOW_INITIAL_QUEUE_SUCCESS,
  GET_WORKFLOW_SECONDARY_QUEUE_SUCCESS,
  GET_WORKFLOW_EXPERT_QUEUE_SUCCESS,
  GET_WORKFLOW_COMPLETE_QUEUE_SUCCESS,
  GET_WORKFLOW_QUEUE_FAILURE,
  GET_USER_QUEUE_REQUEST,
  GET_USER_QUEUE_SUCCESS,
  GET_USER_QUEUE_FAILURE,
  TAKE_QUEUE_ITEM_REQUEST,
  TAKE_QUEUE_ITEM_SUCCESS,
  TAKE_QUEUE_ITEM_FAILURE,
  OPEN_OWNERSHIP_MODAL,
  CLOSE_OWNERSHIP_MODAL,
} from 'actions';

function workflow(state = {
  isFetchingQueues: false,
  isTakingQueueItem: false,
  userQueue: null,
  initialReviewQueue: null,
  secondaryReviewQueue: null,
  expertReviewQueue: null,
  completeQueue: null,
  allQueue: null,
  isOwnershipModalShown: false,
  changeOwnershipItem: null
}, action) {
  switch (action.type) {
    case GET_WORKFLOW_QUEUES_REQUEST:
      return {
        ...state,
        isFetchingQueues: true,
        isTakingQueueItem: false,
      };
    case GET_WORKFLOW_QUEUES_SUCCESS:
      return {
        ...state,
        isFetchingQueues: false,
        isTakingQueueItem: false,
        userQueue: action.userQueue,
        initialReviewQueue: action.initialReviewQueue,
        secondaryReviewQueue: action.secondaryReviewQueue,
        expertReviewQueue: action.expertReviewQueue
      };
    case GET_WORKFLOW_QUEUES_FAILURE:
      return {
        ...state,
        isFetchingQueues: false,
        isTakingQueueItem: false,
        userQueue: action.userQueue,
        initialReviewQueue: action.initialReviewQueue,
        secondaryReviewQueue: action.secondaryReviewQueue,
        expertReviewQueue: action.expertReviewQueue
      };
    case GET_WORKFLOW_QUEUE_REQUEST:
      return {
        ...state,
        isFetchingQueues: true,
        isTakingQueueItem: false,

      };
    case GET_WORKFLOW_INITIAL_QUEUE_SUCCESS:
      return {
        ...state,
        isFetchingQueues: false,
        isTakingQueueItem: false,
        initialReviewQueue: action.initialReviewQueue
      };
    case GET_WORKFLOW_SECONDARY_QUEUE_SUCCESS:
      return {
        ...state,
        isFetchingQueues: false,
        isTakingQueueItem: false,
        secondaryReviewQueue: action.secondaryReviewQueue
      };
    case GET_WORKFLOW_EXPERT_QUEUE_SUCCESS:
      return {
        ...state,
        isFetchingQueues: false,
        isTakingQueueItem: false,
        expertReviewQueue: action.expertReviewQueue
      };
    case GET_WORKFLOW_COMPLETE_QUEUE_SUCCESS:
      return {
        ...state,
        isFetchingQueues: false,
        isTakingQueueItem: false,
        completeQueue: action.completeQueue
      };
    case GET_WORKFLOW_QUEUE_FAILURE:
      return {
        ...state,
        isFetchingQueues: false,
        isTakingQueueItem: false,
      };
    case GET_USER_QUEUE_REQUEST:
      return {
        ...state,
        isFetchingQueues: true,
        isTakingQueueItem: false,
      };
    case GET_USER_QUEUE_SUCCESS:
      return {
        ...state,
        isFetchingQueues: false,
        isTakingQueueItem: false,
        userQueue: action.userQueue
      };
    case GET_USER_QUEUE_FAILURE:
      return {
        ...state,
        isFetchingQueues: false,
        isTakingQueueItem: false,
      };
    case TAKE_QUEUE_ITEM_REQUEST:
      return {
        ...state,
        isFetchingQueues: false,
        isTakingQueueItem: true,
      };
    case TAKE_QUEUE_ITEM_SUCCESS:
      return {
        ...state,
        isFetchingQueues: false,
        isTakingQueueItem: false,
      };
    case TAKE_QUEUE_ITEM_FAILURE:
      return {
        ...state,
        isFetchingQueues: false,
        isTakingQueueItem: false,
      };
    case OPEN_OWNERSHIP_MODAL:
      return {
        ...state,
        isOwnershipModalShown: action.isOwnershipModalShown,
        changeOwnershipItem: action.changeOwnershipItem
      };
    case CLOSE_OWNERSHIP_MODAL:
      return {
        ...state,
        isOwnershipModalShown: action.isOwnershipModalShown,
        changeOwnershipItem: null
      };
    default:
      return state;
  }
}

export default workflow;
